import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../../../components/index";
import { Button, Grid, Typography, Card, CardContent, Stack } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { StoreContext } from "../../../App";
import { Page } from "../../../components";

const FormsSUITT = observer(() => {
  const { auth } = useContext(StoreContext);

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Page title="«Електронні форми»">
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: 2 }}>
            <Card elevation={2} sx={{ maxWidth: 900, mx: "auto" }}>
              <CardContent sx={{ textAlign: "center" }}>
                <Typography variant={"h6"} component={"h1"} sx={{ fontWeight: 500 }}>
                  Інформаційне наповнення сайту ДУІТЗ
                </Typography>
                <Stack spacing={1.25} alignItems={"center"} sx={{ mt: 2 }}>
                  <Button size={"large"} variant={"contained"} component={"a"} target={"_blank"}
                          endIcon={<OpenInNewIcon />}
                          href={`https://docs.google.com/forms/u/3/d/e/1FAIpQLSdd25o28s_uySE-IwE7M4JNSra9VvYM_R2iCZ4X2NfcGZX2CA/viewform`}
                          sx={{ width: { xs: "100%", sm: 520 } }}>
                    Інформація про факультет для розміщення на сайті ДУІТЗ
                  </Button>
                  <Button size={"large"} variant={"contained"} component={"a"} target={"_blank"}
                          endIcon={<OpenInNewIcon />}
                          href={`https://docs.google.com/forms/d/e/1FAIpQLSdp3jA0w4H7BcXH5GwXiUgjsA2rROAnOb0wI7Bl60uBBrTi3A/viewform`}
                          sx={{ width: { xs: "100%", sm: 520 } }}>
                    Інформація про кафедру для розміщення на сайті ДУІТЗ
                  </Button>
                  <Button size={"large"} variant={"contained"} component={"a"} target={"_blank"}
                          endIcon={<OpenInNewIcon />}
                          href={`https://docs.google.com/forms/d/e/1FAIpQLSda72YEpqu-XjV8dBznGNPp3M7A4V8so0kVoliMGnI4eJBBRw/viewform`}
                          sx={{ width: { xs: "100%", sm: 520 } }}>
                    Інформація про професорсько-викладацький склад
                  </Button>
                  <Button size={"large"} variant={"outlined"} component={"a"} target={"_blank"}
                          endIcon={<OpenInNewIcon />}
                          href={`https://docs.google.com/forms/d/e/1FAIpQLSfC8QrnUxK073P6fdRVyjKwErfwYfDLxNGRiQDdDVs08aJcWg/viewform`}
                          sx={{ width: { xs: "100%", sm: 520 } }}>
                    Форма для факультету
                  </Button>
                  <Button size={"large"} variant={"outlined"} component={"a"} target={"_blank"}
                          endIcon={<OpenInNewIcon />}
                          href={`https://docs.google.com/forms/d/e/1FAIpQLSe7w0e9um0IfR-FAANeq1PeHlYjeqCtPHgs5nCENGhjlE5fOA/viewform`}
                          sx={{ width: { xs: "100%", sm: 520 } }}>
                    Форма для кафедри
                  </Button>
                  <Button size={"large"} variant={"outlined"} component={"a"} target={"_blank"}
                          endIcon={<OpenInNewIcon />}
                          href={`https://docs.google.com/forms/d/e/1FAIpQLSdqgProy10VSqsq3IdJ43WIRjhu_kLSFOkbmHOyEOvQes3BEA/viewform`}
                          sx={{ width: { xs: "100%", sm: 520 } }}>
                    Форма для науково-педагогічних працівників
                  </Button>
                  <Button size={"large"} variant={"outlined"} component={"a"} target={"_blank"}
                          endIcon={<OpenInNewIcon />}
                          href={`https://docs.google.com/forms/d/e/1FAIpQLScLWlnCgcdtdzsEh2GO33hwX1hP1jMuvnn_jaQ4D-LwE-4v5A/viewform`}
                          sx={{ width: { xs: "100%", sm: 520 } }}>
                    Форма для співробітників
                  </Button>
                  <Button size={"large"} variant={"outlined"} component={"a"} target={"_blank"}
                          endIcon={<OpenInNewIcon />}
                          href={`https://docs.google.com/forms/d/e/1FAIpQLScS3sM7nGt2uIy9OzWSQWKWI1bbIgD4qIPwgT9stKm6sj5D7w/viewform`}
                          sx={{ width: { xs: "100%", sm: 520 } }}>
                    Форма для студентів
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Page>
    </ErrorBoundary>
  );
});


export default FormsSUITT;
